import React from "react"
import "./Footer.css"

const Footer = () => {
  return (
    <div className="footerContainer">
      <span>Octavi Prats ©</span>
    </div>
  )
}

export default Footer
